import React from 'react'
import { Form, Row, Col, Dropdown } from 'react-bootstrap'
import Swal from 'sweetalert2'
import config from '../../config'
import Cookies from 'js-cookie'

const Search = ({
  setSearchUser,
  setSearchText,
  setCurrentPage,
  handleOnChange,
  searchUser,
  searchText,
  setDigitsSearchType,
  digitsSearchType,
  clearSearch,
  fetchLotteries,
  status,
  roundDate,
  currentPage,
  lengthDigit,
  setLengthDigit,
  setSortType,
  sortType,
}) => {
  const customizeModal = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    })
  }
  const showInputSearchUser = status.isHide === true && status.isBought === true && status.isPublish === true
  const onSearch = () => {
    if (!showInputSearchUser) {
      setSearchUser('')
    }

    if (digitsSearchType === '' && searchText.length < 6 && !showInputSearchUser) {
      Swal.fire({
        title: 'กรอกเลขให้ครบ 6 หลัก',
        text: `กรุณากรอกเลขให้ครบ 6 หลัก `,
        icon: 'error',
      })
      return
    }

    if (currentPage !== 1) {
      setCurrentPage(1)
    } else {
      fetchLotteries(currentPage, searchUser, searchText, status, digitsSearchType, roundDate)
    }
  }

  const handleClickDownloadCSV = async (roundDate, userNo) => {
    const isValidateNumber = /^P[0-9]+$/.test(userNo)

    if (userNo.length === 0) {
      customizeModal('กรุณากรอกรหัสสมาชิก', '', 'error')
      return
    }

    if (!isValidateNumber) {
      customizeModal('กรุณากรอกรหัสสมาชิกให้ถูกต้อง', '', 'error')
      return
    }

    try {
      await fetch(`${config.apiAdminGateway}/api/v2/admin/lotteries/download/${roundDate}/${userNo}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.status !== 200) throw new Error(response.status)
          return response.blob()
        })
        .then((blobData) => {
          const url = window.URL.createObjectURL(new Blob([blobData]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${userNo}-${roundDate}.csv`)
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
        })
      customizeModal(`โหลด CSV สำเร็จ`, '', 'success')
    } catch (error) {
      customizeModal('โหลด CSV ไม่สำเร็จ', 'กรุณาตรวจสอบรหัสสมาชิกให้ถูกต้อง', 'error')
    }
  }

  return (
    <Form>
      <Row sm={12}>
        <Col sm={12} md={6} lg={6}>
          <div className="d-flex pt-2 pb-2">
            {showInputSearchUser && (
              <input
                type="text"
                placeholder="รหัสสมาชิก"
                value={searchUser}
                className="form-control mr-2"
                style={{ color: '#5d5d5d' }}
                onChange={(e) => {
                  const value = e.target.value.toLocaleUpperCase()
                  setSearchUser(value)
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleOnChange(e)
                  }
                }}
              />
            )}
            <input
              type="text"
              placeholder="เลขที่ต้องการ"
              value={searchText}
              maxLength={lengthDigit}
              className="form-control mr-2"
              style={{ color: '#5d5d5d' }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '')
                setSearchText(value)
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleOnChange(e)
                }
              }}
            />
            <Col sm={12} md={6} lg={3}>
              {
                <Dropdown>
                  <Form.Control
                    as="select"
                    value={digitsSearchType}
                    onChange={(value) => {
                      setDigitsSearchType(() => value.target.value)
                      setSearchText('')
                      setLengthDigit(() =>
                        value.target.value === '' ? 6 : value.target.value === 'LAST_TWO_DIGITS' ? 2 : 3,
                      )
                    }}
                  >
                    <option value="">ทั้งหมด</option>
                    <option value="LAST_TWO_DIGITS">2 ตัวท้าย</option>
                    <option value="LAST_THREE_DIGITS">3 ตัวท้าย</option>
                    <option value="FIRST_THREE_DIGITS">3 ตัวหน้า</option>
                  </Form.Control>
                </Dropdown>
              }
            </Col>
            <Col sm={12} md={6} lg={3}>
              {
                <Dropdown>
                  <Form.Control
                    as="select"
                    value={sortType}
                    onChange={(value) => {
                      setSortType(() => value.target.value)
                    }}
                  >
                    <option value="ASC">เรียงจากน้อยไปมาก</option>
                    <option value="DESC">เรียงจากมากไปน้อย</option>
                  </Form.Control>
                </Dropdown>
              }
            </Col>
          </div>
        </Col>
        <div
          className="btn btn-primary light align-self-center "
          style={{ minWidth: '120px' }}
          onClick={() => onSearch()}
        >
          ค้นหา
        </div>
        <div
          className="btn btn-primary light align-self-center"
          style={{ minWidth: '120px', marginLeft: '10px' }}
          onClick={() => clearSearch()}
        >
          ล้างการค้นหา
        </div>
        {showInputSearchUser && (
          <div
            className="btn btn-danger light align-self-center"
            style={{ minWidth: '100px', marginLeft: '10px' }}
            onClick={() => handleClickDownloadCSV(roundDate, searchUser)}
          >
            Download Image links
          </div>
        )}
      </Row>
    </Form>
  )
}

export default Search
